export enum TapesFields {
  width = "width",
  material = "material",
  mainColor = "mainColor",
  numberOfPrintColors = "numberOfPrintColors",
  designFile = "designFile",
  amountBoxes = "amountBoxes",
  otherAmountBoxes = "otherAmountBoxes",
}
